import React from 'react';
import { Link } from 'react-router-dom';
// import slugify from 'slugify';
import {
  Box,
  Image,
  Flex,
  Text,
  useColorMode,
  Skeleton,
} from '@chakra-ui/core';
import { connect } from 'react-redux';
import { FaEuroSign } from 'react-icons/fa';
import ReactStars from 'react-rating-stars-component';

function Rec(props) {
  const [loaded, setloaded] = React.useState(false);
  const imageLoaded = () => {
    setloaded(true);
  };

  const { colorMode } = useColorMode();
  const color = { light: 'gray.800', dark: 'white' };
  const bg = { light: 'white', dark: 'black' };
  //   React.useEffect(() => {
  //     window.addEventListener('load', event => {
  //       console.log('page is fully loaded');
  //       setloaded(true);
  //     });
  //   }, []);

  //   const slug = slugify(props.name);
  let distance = null;
  if (props.position && props.latitude) {
    const R = 6371e3; // metres
    const φ1 = (props.latitude * Math.PI) / 180; // φ, λ in radians
    const φ2 = (props.position.latitude * Math.PI) / 180;
    const Δφ = ((props.position.latitude - props.latitude) * Math.PI) / 180;
    const Δλ = ((props.position.longitude - props.longitude) * Math.PI) / 180;

    const a =
      Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
      Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    const d = R * c; // in metres
    distance = d / 1000;
  }

  ///////count rate/////////////////////////////
  //   let totalRate = 0;
  //   let Rate;
  //   props.reviews.map(review => {
  //     totalRate += review.rate;
  //   });
  //   Rate = totalRate / props.reviews.length;

  ////////////////////////////////////////////////

  return (
    <Link key={props.key} to={`restaurant/${props.id}`}>
      <Box
        _hover={{ transform: 'scale(1.05)' }}
        transition="transform ease-in 0.1s"
        key={props.key}
        shadow="sm"
        cursor="pointer"
        bg={bg[colorMode]}
        maxW="sm"
        // borderWidth="1px"
        rounded="30px"
        // h="300px"
      >
        <Box
          // minW="250px"
          h="200px"
          //   rounded="30px"
          roundedTopRight="30px"
          roundedTopLeft="30px"
          bg={'black'}
          position="relative"
        >
          <Skeleton
            roundedTopRight="30px"
            roundedTopLeft="30px"
            isLoaded={loaded}
          >
            <Image
              onLoad={imageLoaded}
              h="200px"
              w="100%"
              roundedTopRight="30px"
              roundedTopLeft="30px"
              objectFit="cover"
              opacity="0.7"
              src={props.image}
              alt={props.name}
            />
          </Skeleton>

          <Text color="white" position="absolute" top="10px" left="10px">
            {' '}
            {distance && distance.toFixed(1) + ' km'}
          </Text>
        </Box>

        <Box p="3">
          <Box
            color="red.500"
            fontWeight="bold"
            fontSize="14px"
            lineHeight="tight"
            isTruncated
          >
            {props.name}
          </Box>
          <Box>
            <Box
              minH="70px"
              //   height="auto"
              color={color[colorMode]}
              fontWeight="semibold"
              lineHeight="tight"
              fontSize="sm"
              textTransform="uppercase"
              //   isTruncated={[true, true, false, false]}
              //   ml="2"
            >
              {props.adress}
            </Box>
          </Box>
          <Flex justifyContent="space-between">
            <Box color="gray.900" d="flex" mt="2" alignItems="center">
              <ReactStars
                value={props.rate}
                count={5}
                edit={false}
                size={20}
                activeColor="#ffd700"
              />
              {/* <Box as="span" ml="2" color="gray.600" fontSize="sm">
                {property.reviewCount}
              </Box> */}
            </Box>
            <Box
              color="red.500"
              display="flex"
              mt="3"
              //   dir="column"
              //   alignItems="flex-end"
            >
              {props.prix !== '' &&
                props.prix !== null &&
                props.prix !== undefined &&
                [...Array(Number(props.prix))].map(() => (
                  <FaEuroSign key={Math.random()}></FaEuroSign>
                ))}
              {/* <FaEuroSign></FaEuroSign>
              <FaEuroSign></FaEuroSign> */}
            </Box>
          </Flex>
        </Box>
      </Box>
    </Link>
  );
}

const mapStateToProps = state => {
  return { position: state.location };
};

export default connect(mapStateToProps, null)(Rec);
